import { ISymbolLpStoreSegment } from './symbolLp.interface';

export const symbolLpStoreSelector = (state: ISymbolLpStoreSegment) => state.symbolLp;
